module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading"
  }, [_c('h1', [_vm._v("404")]), _vm._v(" "), _c('p', [_vm._v("您输入的地址有误，或该页面已变更")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-349e586d","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/not-found.vue
// module id = 677
// module chunks = 57